import { render, staticRenderFns } from "./HotlistTempForm.vue?vue&type=template&id=63b01f6e&scoped=true&"
import script from "./HotlistTempForm.vue?vue&type=script&lang=js&"
export * from "./HotlistTempForm.vue?vue&type=script&lang=js&"
import style0 from "./HotlistTempForm.vue?vue&type=style&index=0&id=63b01f6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b01f6e",
  null
  
)

export default component.exports